var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"purchase-in-app-button button",on:{"click":_vm.jumpToPurchase}},[_c('span',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.$t(_vm.app_store_text)))])])}
var staticRenderFns = []

export { render, staticRenderFns }